import { Link } from "react-router-dom";
import { CheckCircle2, CalendarCheck, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteLayout, PageHero, SectionTag, useSEO } from "./shared";

const COVERAGE = [
  "Fire Alarm System AMC",
  "Fire Hydrant System AMC",
  "Sprinkler System AMC",
  "Fire Pump System AMC",
  "Fire Extinguisher Inspection & Servicing",
  "Emergency Lighting Inspection",
  "Preventive Maintenance",
  "Breakdown Support",
  "Testing & Inspection",
  "Maintenance Documentation",
];

export default function AMC() {
  useSEO(
    "Annual Maintenance Contracts (AMC) | SecureFlame Fire Systems Tripura",
    "SecureFlame offers Annual Maintenance Contracts covering fire alarm, hydrant, sprinkler, pump and extinguisher systems across Tripura — preventive maintenance, testing and breakdown support."
  );
  return (
    <SiteLayout>
      <PageHero eyebrow="AMC" title="Annual Maintenance Contracts" subtitle="Scheduled preventive maintenance and testing keeps your fire protection systems reliable and ready year-round." />

      <section className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="max-w-2xl mb-10">
          <SectionTag>What's Covered</SectionTag>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-secondary">Complete AMC coverage.</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {COVERAGE.map((c) => (
            <div key={c} className="flex items-start gap-3 p-5 rounded-sm border border-border bg-card">
              <CheckCircle2 size={18} className="text-primary shrink-0 mt-0.5" />
              <span className="text-sm font-medium text-secondary">{c}</span>
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-foreground italic max-w-2xl">AMC scope and pricing depend on the systems installed at your site — we prepare a proposal after reviewing your requirements. Published prices are not available online.</p>
      </section>

      <section className="bg-secondary text-white">
        <div className="max-w-4xl mx-auto px-6 py-16 md:py-20 text-center">
          <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Ready to Set Up an AMC?</h2>
          <p className="mt-4 text-slate-300 max-w-xl mx-auto">Choose the option that fits your need — we'll follow up with next steps.</p>
          <div className="mt-8 flex flex-wrap gap-3.5 justify-center">
            <Link to="/contact?type=quote&service=amc"><Button size="lg" className="rounded-sm bg-primary hover:bg-primary/90 font-semibold gap-2" data-testid="amc-proposal-btn"><CalendarCheck size={18} /> REQUEST AMC PROPOSAL</Button></Link>
            <Link to="/contact?type=site_visit&service=amc"><Button size="lg" variant="outline" className="rounded-sm border-white/25 text-white bg-transparent hover:bg-white/10 font-semibold gap-2" data-testid="amc-inspection-btn"><Wrench size={18} /> SCHEDULE SYSTEM INSPECTION</Button></Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
